import { render, staticRenderFns } from "./ExpansionSettingsComponent.vue?vue&type=template&id=22066a44&scoped=true"
import script from "./ExpansionSettingsComponent.vue?vue&type=script&lang=js"
export * from "./ExpansionSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./ExpansionSettingsComponent.vue?vue&type=style&index=0&id=22066a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22066a44",
  null
  
)

export default component.exports